module.exports = __webpack_public_path__ + "img/ico-whatsapp-flotante.8469a95b.png";